import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
// import logo from '../../assets/images/logos/logo-no-background-title-only.png';
import logo from "../../assets/images/logos/prime-logo.png";

const Navbar = () => {
          const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
          const [isMenuOpen, setIsMenuOpen] = useState(false);
          const navbarRef = useRef(null);
          const location = useLocation();

          const toggleMobileMenu = () => {
                    setIsMenuOpen(!isMenuOpen);
          };

          const closeMobileMenu = () => {
                    setIsMenuOpen(false);
          };

          const scrollToSection = (sectionId) => {
                    const section = document.getElementById(sectionId);
                    if (section) {
                              const navbarHeight =
                                        navbarRef.current.offsetHeight;
                              const sectionPosition =
                                        section.offsetTop - navbarHeight;
                              window.scrollTo({
                                        top: sectionPosition,
                                        behavior: "smooth",
                              });
                              closeMobileMenu();
                    }
          };

          // Define navLinks based on current route
          const navLinks =
                    location.pathname === "/request-service"
                              ? [{ id: "/", label: "Home", type: "route", isButton: true }]
                              : [
                                          {
                                                    id: "about-us",
                                                    label: "About Us",
                                                    type: "section",
                                          },
                                          {
                                                    id: "our-services",
                                                    label: "Services",
                                                    type: "section",
                                          },
                                          {
                                                    id: "pricing",
                                                    label: "Pricing",
                                                    type: "section",
                                          },
                                          {
                                                    id: "reviews",
                                                    label: "Testimonials",
                                                    type: "section",
                                          },
                                          {
                                                    id: "/request-service",
                                                    label: "Request Service",
                                                    type: "route",
                                                    isButton: true,
                                          },
                                ];

          useEffect(() => {
                    const handleResize = () => {
                              setIsMobile(window.innerWidth <= 768);
                    };
                    window.addEventListener("resize", handleResize);

                    return () => {
                              window.removeEventListener(
                                        "resize",
                                        handleResize
                              );
                    };
          }, []);

          return (
                    <nav
                              ref={navbarRef}
                              className={`navbar ${isMobile ? "mobile" : ""}`}
                    >
                              <div className="navbar-content">
                                        <div className="navbar-logo">
                                                  <Link
                                                            to="/"
                                                            onClick={
                                                                      closeMobileMenu
                                                            }
                                                  >
                                                            <img
                                                                      src={logo}
                                                                      alt="Logo"
                                                            />
                                                  </Link>
                                        </div>

                                        {/* Hamburger Menu Button */}
                                        {isMobile && (
                                                  <button
                                                            className="hamburger-menu"
                                                            onClick={
                                                                      toggleMobileMenu
                                                            }
                                                  >
                                                            <span
                                                                      className={`hamburger-line ${
                                                                                isMenuOpen
                                                                                          ? "open"
                                                                                          : ""
                                                                      }`}
                                                            ></span>
                                                            <span
                                                                      className={`hamburger-line ${
                                                                                isMenuOpen
                                                                                          ? "open"
                                                                                          : ""
                                                                      }`}
                                                            ></span>
                                                            <span
                                                                      className={`hamburger-line ${
                                                                                isMenuOpen
                                                                                          ? "open"
                                                                                          : ""
                                                                      }`}
                                                            ></span>
                                                  </button>
                                        )}

                                        {/* Desktop Menu */}
                                        {!isMobile && (
                                                  <ul className="navbar-menu">
                                                            {navLinks.map(
                                                                      (
                                                                                link
                                                                      ) => (
                                                                                <li
                                                                                          key={
                                                                                                    link.id
                                                                                          }
                                                                                          className={`menu-item ${
                                                                                                    link.isButton
                                                                                                              ? "menu-button"
                                                                                                              : ""
                                                                                          }`}
                                                                                          onClick={
                                                                                                    link.type ===
                                                                                                    "section"
                                                                                                              ? () =>
                                                                                                                          scrollToSection(
                                                                                                                                    link.id
                                                                                                                          )
                                                                                                              : undefined
                                                                                          }
                                                                                >
                                                                                          {link.type ===
                                                                                          "route" ? (
                                                                                                    <Link
                                                                                                              to={
                                                                                                                        link.id
                                                                                                              }
                                                                                                              
                                                                                                    >
                                                                                                              {
                                                                                                                        link.label
                                                                                                              }
                                                                                                    </Link>
                                                                                          ) : (
                                                                                                    link.label
                                                                                          )}
                                                                                </li>
                                                                      )
                                                            )}
                                                  </ul>
                                        )}

                                        {/* Mobile Menu */}
                                        {isMobile && (
                                                  <ul
                                                            className={`navbar-menu mobile-menu ${
                                                                      isMenuOpen
                                                                                ? "open"
                                                                                : ""
                                                            }`}
                                                  >
                                                            {navLinks.map(
                                                                      (
                                                                                link
                                                                      ) => (
                                                                                <li
                                                                                          key={
                                                                                                    link.id
                                                                                          }
                                                                                          className={`menu-item ${
                                                                                                    link.isButton
                                                                                                              ? "menu-button"
                                                                                                              : ""
                                                                                          }`}
                                                                                          onClick={
                                                                                                    link.type ===
                                                                                                    "section"
                                                                                                              ? () =>
                                                                                                                          scrollToSection(
                                                                                                                                    link.id
                                                                                                                          )
                                                                                                              : closeMobileMenu
                                                                                          }
                                                                                >
                                                                                          {link.type ===
                                                                                          "route" ? (
                                                                                                    <Link
                                                                                                              to={
                                                                                                                        link.id
                                                                                                              }
                                                                                                              style={{
                                                                                                                        textDecoration:
                                                                                                                                  "none",
                                                                                                                        color: "inherit",
                                                                                                              }}
                                                                                                              onClick={
                                                                                                                        closeMobileMenu
                                                                                                              }
                                                                                                    >
                                                                                                              {
                                                                                                                        link.label
                                                                                                              }
                                                                                                    </Link>
                                                                                          ) : (
                                                                                                    link.label
                                                                                          )}
                                                                                </li>
                                                                      )
                                                            )}
                                                  </ul>
                                        )}
                              </div>
                    </nav>
          );
};

export default Navbar;
